import React, { useRef } from "react"
import styled, { ThemeProvider } from "styled-components"
import { darkTheme } from "src/utils/themes"
import { ApprenticeshipHeader } from "src/components/Header"
import { rem } from "src/utils/styling"
import { PageSection } from "src/components/PageSection"
import Button from "../../components/Button"
import { HiChevronRight } from "react-icons/hi"
import { LightFooter } from "src/components/Footer"
import { ReactTypeformEmbed } from "react-typeform-embed"
import HowItWorksCard from "../../components/apprenticeship/howitworks-card"
import Commitment from "../../components/apprenticeship/commitment"
import Mentor from "../../components/apprenticeship/mentor"
import ApprenticeshipBanner from "../../components/apprenticeship/apprenticeship-banner"

import { apprenticeHowItWorksData } from "src/data/apprenticeData"
import SEO from "src/components/seo"

const Section = styled(PageSection)`
  padding: ${rem(50)}rem 0;
  position: relative;
  background-color: ${props => (props.color ? props.color : "transparent")};
  @media screen and (min-width: 1100px) {
    padding: ${rem(10)}rem 0;
  }
  @media screen and (max-width: 1100px) {
    padding: ${rem(5)}rem 0;
  }
  @media screen and (max-width: 550px) {
    padding: ${rem(20)}rem 0;
  }
`
const HowItWorksContainer = styled.div`
  width: 100%;
  padding: 0 26px;
  margin: 0 0 ${rem(200)}rem;
  position: relative;
  box-sizing: border-box;

  @media screen and (min-width: 1100px) {
    flex-direction: column;
    width: 1100px;
    padding: 0 30px;
    margin: auto;
  }
  @media screen and (min-width: 1280px) {
    width: 1240px;
    margin: auto;
  }
  @media screen and (min-width: 1600px) {
    width: 1440px;
    margin: auto;
  }
`

const SectionTitle = styled.h2`
  font-weight: 800;
  font-size: ${rem(24)}rem;
  color: ${props => (props.color ? props.color : "#000000")};
  text-align: center;
  align-self: center;

  > em {
    font-style: normal;
    color: #00b8c5;
  }

  @media screen and (min-width: 1100px) {
    font-size: ${rem(34)}rem;
  }
`

export const PageButton = styled(Button)`
  font-size: ${rem(18)}rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  @media screen and (max-width: 550px) {
    font-size: ${rem(15)}rem;
    padding: 0.4rem 1rem;
  }
  @media screen and (min-width: 1100px) {
    margin: 0;
  }
`

const CTAContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${rem(100)}rem ${rem(140)}rem;
  background: linear-gradient(283.7deg, #03162c 28.07%, #4d5357 185.43%);
  border-radius: 20px;
  width: 90%;
  margin: 0 auto -${rem(180)}rem;
  @media screen and (max-width: 500px) {
    padding: 60px;
  }
  @media screen and (min-width: 1100px) {
    width: 894px;
  }
`

const CTAContainerInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const Apprentice = ({ location }) => {
  const typeformRef = useRef()
  const onClickTypeform = () => {
    typeformRef.current && typeformRef.current.typeform.open()
  }
  return (
    <ThemeProvider theme={darkTheme}>
      <SEO
        title="Apprentice at Top Tier Startups"
        description="Providing aspiring developers from across the world a window of
          opportunity to intern with top-tier, venture funded startups while
          being mentored by the best in the industry"
        location={location}
      />
      <ApprenticeshipHeader />
      <ApprenticeshipBanner />
      <ReactTypeformEmbed
        popup
        autoOpen={false}
        hideHeaders
        hideFooter
        url="https://jfox813621.typeform.com/to/knCQHiPn"
        ref={typeformRef}
      />
      <Section>
        <HowItWorksContainer>
          <SectionTitle>How it Works</SectionTitle>
          {apprenticeHowItWorksData.map((item, idx) => (
            <HowItWorksCard
              key={`card-${idx}`}
              cardIndex={idx}
              title={item.title}
              text={item.text}
              timelineTitle={item.timelineTitle}
              tiimelineText={item.tiimelineText}
              desktopImage={item.desktopImage}
              desktopImage2={item.desktopImage2}
              mobileImage={item.mobileImage}
            />
          ))}
        </HowItWorksContainer>
      </Section>
      <Commitment />
      <Mentor />
      <Section>
        <CTAContainer>
          <CTAContainerInner>
            <SectionTitle color={"#fff"} style={{ paddingBottom: 20 }}>
              Join the Apprenticeship Program!
            </SectionTitle>
            <div onClick={onClickTypeform}>
              <PageButton type="solid">
                Apply Now
                <HiChevronRight size={22} />
              </PageButton>
            </div>
          </CTAContainerInner>
        </CTAContainer>
      </Section>
      <LightFooter paddingTop={280} />
    </ThemeProvider>
  )
}

export default Apprentice
